import React from 'react';
import { Table } from 'react-bootstrap';

const params = [ [ 'partnerRequests', 'Partner Requests' ], [ 'cpc', 'CPC' ], [ 'wins', 'Wins' ], [ 'winsPercent', 'Win %' ], [ 'clicks', 'Clicks'], [ 'impressions', 'Impressions' ], [ 'ctr', 'CTR' ], [ 'eCpm', 'ECpm' ], [ 'revenue', 'Revenue' ] ];

const BidderTable = ({ data, sources }) => {
    const header = sources.map(source => <th key={source}>{source}</th>);

    const rows = data.reduce((arr, { hour, country, ...data }, globalIndex) => {
        params.forEach(([ param, paramName ], index) => {
            const hourTd = index === 0 ? <td rowSpan={9}>{hour}</td> : null;
            const countryTd = index === 0 ? <td rowSpan={9}>{country}</td> : null;
            const valuesTd = sources.map(source => <td>{data[param][source]}</td>);

            arr.push((
                <tr key={`${globalIndex}_${index}`}>
                    {hourTd}
                    {countryTd}
                    <td>{paramName}</td>
                    {valuesTd}
                    <td>{data[`${param}Total`]}</td>
                </tr>
            ));
        });

        return arr;
    }, []);

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th>Hour</th>
                <th>Country</th>
                <th>Parameter</th>
                {header}
                <th>Total</th>
            </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
};

export default BidderTable;


// WEBPACK FOOTER //
// ./src/scenes/BidderHourly/components/Table/index.js